
export const NAME_REDUCER = 'report';

export const PREFIX_ACTIONS = 'report_feature_';

export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
};
